import { render } from "./indexfivestore.vue?vue&type=template&id=0f85f3f4"
import script from "./indexfivestore.vue?vue&type=script&lang=js"
export * from "./indexfivestore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__